// src/modules/ProfitAndLossModule.tsx
import ProfitAndLossOverview from "@/components/profit_and_loss/ProfitAndLossOverview";
import ProfitAndLossGraph from "@/components/profit_and_loss/ProfitAndLossGraph";
import ProfitAndLossMonthly from "@/components/profit_and_loss/ProfitAndLossMonthly";
import ProfitAndLossRawData from "@/components/profit_and_loss/ProfitAndLossRawData";

import { useProfitAndLoss } from "@/hooks/use-profit-and-loss";
import { useProfitAndLossVoucherRowsRange } from "@/hooks/use-profit-and-loss-voucher-rows";
import { useProfitAndLossMonthlyGraphRange } from "@/hooks/use-profit-and-loss-monthly-graph";
import { useProfitAndLossMonthlyRange } from "@/hooks/use-profit-and-loss-monthly";

import FinancialPagePnLRange from "@/components/profit_and_loss/FinancialPagePnLRange";
import { useTranslation } from "react-i18next";

const ProfitAndLossModule = () => {
  const { t } = useTranslation();
  return (
    <FinancialPagePnLRange
      title={t("profit_and_loss:title")}
      overviewHook={useProfitAndLoss}
      graphHook={useProfitAndLossMonthlyGraphRange}
      monthlyHook={useProfitAndLossMonthlyRange}
      rawHook={useProfitAndLossVoucherRowsRange}
      OverviewComponent={ProfitAndLossOverview}
      GraphComponent={ProfitAndLossGraph}
      MonthlyComponent={ProfitAndLossMonthly}
      RawComponent={ProfitAndLossRawData}
    />
  );
};

export default ProfitAndLossModule;
